module.exports = __webpack_public_path__ + "media/public/logo_sin_texto-6a44908c.png";